$ = jQuery;

// Go step back
function goBack() {
  window.history.back();
}

// SMALLER HEADER AFTER SCROLL

var cbpAnimatedHeader = (function() {

  var docElem = document.documentElement,
  header = document.querySelector( 'header' ),
  didScroll = false,
  changeHeaderOn = 300;

  function init() {
    window.addEventListener( 'scroll', function( event ) {
      if( !didScroll ) {
        didScroll = true;
        setTimeout( scrollPage, 250 );
      }
    }, false );
  }

  function scrollPage() {
    var sy = scrollY();
    if ( sy >= changeHeaderOn ) {
      classie.add( header, 'small-scroll' );
      classie.add( mobile_nav, 'small' );
    }
    else {
      classie.remove( header, 'small-scroll' );
      classie.remove( mobile_nav, 'small' );
    }
    didScroll = false;
  }

  function scrollY() {
    return window.pageYOffset || docElem.scrollTop;
  }

  init();

})();

// GRID MASONRY LAYOUT

$(document).ready(story_masonry);
$(window).on('resize',story_masonry);

function story_masonry(){
  $('.box-wrapper').masonry({
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    isOriginLeft: true
  });
}


// SCROLL FIXED BANNER
 $.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function() {
  if( $(window).width() > 991 ){
  $('footer').each(function() {
    if ($(this).isInViewport()) {
        var viewportTop = $(window).scrollTop() + $(window).height();;
        var elementTop = $(this).offset().top;
        var bottomPx = viewportTop - elementTop;

      $('.aside-banner').css({
          'top':'auto',
          'bottom': bottomPx
      });
    } else {
        $('.aside-banner').css({
        'top':'50px',
        'bottom': 'auto'
        });
    }
  });
};
});



// BURGER MENU
$('.hamburger').click(function(){
  $('.hamburger').toggleClass('is-active');

  var mobilenav = $('.mobile-nav');
  mobilenav.toggleClass('open');
  mobilenav.hasClass('open')? mobilenav.css({'transform': 'translateY(0%)','opacity': '1'}) : mobilenav.css({'transform': 'translateY(-120%)','opacity': '0'});


})

// SCROLL UP

function scrollUp() {
  $("html, body").animate({
    scrollTop: 0
  }, 300);
}

// Hide arrow if text is more than 70% height in article detail

var headlines = $(".headlines").height();
var headlines_par = $(".headlines p").height();

var height = (headlines_par*100)/headlines;

if(height > 70){
	$("#down-arrow-detail").css("display", "none")
}
